import * as React from 'react';
import cn from 'classnames';
import { Tooltip, UIHeading4, UIText2 } from '@cian/ui-kit';
import { CompetitionLabel } from './CompetitionLabel/CompetitionLabel';
import * as styles from './Competitors.css';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../../../selectors/layout';
import { ICompetitorsProps } from './types';
import { useMediaQuery } from '../../../../../../hooks';

export const Competitors = ({ level, promotions }: ICompetitorsProps) => {
  const isMobile = useSelector(selectIsMobileLayout);
  const narrowScreen = useMediaQuery('(min-width: 1024px) and (max-width: 1200px)');

  if (!promotions.length || !level) {
    return null;
  }

  const withBorder = isMobile || narrowScreen;
  const className = cn(styles.root, withBorder && styles['with-border'], narrowScreen && !isMobile && styles['narrow']);

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.heading}>
        <UIHeading4 display="inline">Конкуренция</UIHeading4>
        <CompetitionLabel level={level} />
      </div>
      <ul className={styles.list}>
        {promotions.map(({ amount, title, selected }) => (
          <li className={styles.item} key={title}>
            <UIText2 fontWeight={selected ? 'bold' : 'normal'}>{title}</UIText2>
            <UIText2 fontWeight={selected ? 'bold' : 'normal'}>{amount}</UIText2>
          </li>
        ))}
      </ul>
      <Tooltip
        title="Прогнозируем, сколько будет похожих объявлений в поиске: в этой же категории, районе или области и в этом ценовом диапазоне"
        theme="black"
        placement="bottom"
      >
        <span className={cn(styles['pseudo-link'], !withBorder && styles['pseudo-link_dashed'])}>
          Как считаем конкуренцию
        </span>
      </Tooltip>
    </div>
  );
};
